module.exports = __webpack_public_path__ + "static/media/app_logout.05d042de.svg";